export default {
  integration: {
    see_line_data:'点击查看历史曲线图',
    alarm_or_not: '是否报警',
    mount_: '资产',
    success: '成功',
    'on-line': '在线',
    stop_it: '停止',
    normal_reporting_data: '正常上报数据',
    not_in_flight_mode: '不处于飞行模式',
    flight_mode: '飞行模式',
    gateway_name_: '网关名称',
    gateway_nickname: '网关昵称',
    battery_supply: '电池供应',
    gateway_heartbeat_history: '网关心跳历史',
    abnormal_sensor_connection: '传感器连接异常',
    abnormal_sensor_temperature: '传感器温度异常',
    abnormal_sensor_humidity: '传感器湿度异常',
    gateway_connection_exception: '网关连接异常',
    gateway_power_failure_exception: '网关断电异常',
    abnormal_connection_of_display_screen: '显示屏连接异常',
    abnormal_relay_connection: '中继连接异常',
    handle: '处理',
    handle_event: '处理事件',
    return_processing: '返回处理',
    processed_successfully: '处理成功',
    parameter_error: '参数错误',
    the_corresponding_reason_cannot_be_found: '找不到对应的原因',
    associated_device_not_found: '关联设备找不到',
    illegal_handler: '处理人不合法',
    exception_record_not_found: '找不到异常记录',
    illegal_description: '描述不合法',
    processing_time_: '处理时间',
    trunk_number: '中继编号',
    relay_nickname: '中继昵称',
    relay_type: '中继类型',
    update_time: '更新时间',
    sensor_number: '传感器编号',
    sensor_type: '传感器类型',
    sensor_status: '传感器状态',
    acquisition_interval: '采集间隔',
    abnormal_collection_interval: '异常采集间隔',
    temperature_acquisition_interval: '温度采集间隔',
    temperature_change_threshold: '温度变化阈值',
    maximum_temperature_reporting_interval: '温度最大上报间隔',
    minimum_temperature_reporting_interval: '温度最小上报间隔',
    humidity_collection_interval: '湿度采集间隔',
    humidity_change_threshold: '湿度变化阈值',
    maximum_humidity_reporting_interval: '湿度最大上报间隔',
    humidity_minimum_reporting_interval: '湿度最小上报间隔',
    text: '文本',
    switch_to_line_chart: '切换为折线图',
    switch_to_histogram: '切换为柱状图',
    picture_download: '图片下载',
    line_chart: '折线图',
    switch_language_successfully: '切换语言成功',
    tips: '提示',
    add_exception_reason_definition: '新增起因',
    the_last_piece_of_data_cannot_be_deleted: '最后一条数据不能删除',
    reason_cannot_be_empty: '原因不能为空',
    fail: '失败',
    name_already_exists: '名称已存在',
    data_error: '数据错误',
    refrigerator: '冰箱',
    vehicle: '车辆',
    cold_storage: '冷库',
    retention_exception: '保留异常',
    no_more: '没有更多了',
    load_more: '加载更多',
    scroll_to_the_bottom_to_load_more: '滚动到底部加载更多',
    name_cannot_be_empty: '名称不能为空',
    code_cannot_be_empty: '编码不能为空',
    code_already_exists: '编码已存在',
    the_added_node_type_is_incorrect: '添加的节点类型不对',
    failed_to_add: '新增失败',
    update_successful: '更新成功',
    update_failed: '更新失败',
    the_longitude_entered_is_illegal: '输入的经度不合法',
    the_latitude_entered_is_illegal: '输入的纬度不合法',
    longitude_cannot_be_empty: '经度不能为空',
    latitude_cannot_be_empty: '纬度不能为空',
    successful_positioning: '定位成功',
    upload_successful: '上传成功',
    abnormal: '异常',
    happen: '发生',
    normal: '正常',
    no_temperature_monitoring_section: '无温度监测区间',
    humidity_free_monitoring_section: '无湿度监测区间',
    select_at_least_one_mount_to_remove: '至少选择一个资产移除',
    deleting_fixed_points_needs_to_be_done_in_edit_mode: '删除定点需要在编辑模式中进行',
    successfully_deleted: '删除成功',
    there_are_no_removable_mounting_anchors: '暂无可移除的资产锚点',
    position_cannot_be_empty: '位置不能为空',
    carrier_cannot_be_empty: '载体不能为空',
    add_to: '添加',
    only_peer_nodes_are_allowed_to_drag: '只允许平级节点拖拽',
    drag_succeeded: '拖拽成功',
    new_contact_information: '新增联系方式',
    synchronization_failed: '同步失败',
    synchronization_successful: '同步成功',
    customer_cannot_be_empty: '企业不能为空',
    mobile_number_cannot_be_empty: '手机号码不能为空',
    mailbox_cannot_be_empty: '邮箱不能为空',
    please_enter_the_correct_email_address: '请输入正确的邮箱地址',
    mobile_number_already_exists: '手机号码已存在',
    mailbox_already_exists: '邮箱已存在',
    monitoring_interval_already_exists: '已存在监测区间',
    system_error: '系统错误',
    name: '名称',
    export_type: '导出类型',
    state: '状态',
    select_at_least_one_piece_of_data: '至少选择一条数据',
    delete_failed: '删除失败',
    download_failed: '下载失败',
    the_file_does_not_exist: '该文件不存在',
    the_file_has_been_deleted: '该文件已被删除',
    zhang_san: '张三',
    task_cannot_be_empty: '任务不能为空',
    interval_cannot_be_empty: '间隔不能为空',
    hour: '时',
    day: '天',
    task_content_cannot_be_empty: '任务内容不能为空',
    execution_interval_cannot_be_empty: '执行间隔不能为空',
    task_failed: '任务失败',
    running: '运行',
    new_task: '新增任务',
    'are_you_sure_about_this_operation?': '您确定此操作吗？',
    trigger: '触发',
    data_cannot_be_empty: '数据不能为空',
    every_day: '每天',
    the_first_day_of_each_week: '每周第一天',
    last_day_of_the_week: '每周最后一天',
    the_first_day_of_each_month: '每月第一天',
    last_day_of_each_month: '每月最后一天',
    first_day_of_each_quarter: '每季度第一天',
    last_day_of_each_quarter: '每季度最后一天',
    the_first_day_of_each_year: '每年第一天',
    last_day_of_each_year: '每年最后一天',
    print_every_two_minutes: '每个两分钟打印',
    newly_added: '新增',
    keep_at_least_one_acquisition_time: '至少保留一个采集时间',
    keep_at_least_one_print_setting_time: '至少保留一个打印设置时间',
    printer_collection: '打印机集合',
    keep_at_least_one_printer: '至少保留一个打印机',
    please_select_at_least_one_print_group_information:
      '请至少选择一个打印分组信息',
    please_select_at_least_one_sensor_data: '请至少选择一个传感器数据',
    the_selected_data_has_sensorless_correlation:
      '所选择的数据存在无传感器关联情况',
    please_select_at_least_one_printer: '请至少至少选择一个打印机',
    time_selection_has_empty_time: '时间选择存在空的时间',
    contact_cannot_be_empty: '联系人不能为空',
    phone_number_cannot_be_empty: '电话号码不能为空',
    please_enter_email_address: '请输入电子邮箱',
    level_name_cannot_be_empty: '层级名称不能为空',
    keep_at_least_one: '至少保留一项',
    please_enter_an_integer: '请输入整数',
    select_at_least_one_day_of_alarm_time: '至少选择一天报警时间',
    fill_at_least_one_time_point_for_each_item: '每一项天数至少填充一个时间点',
    trigger_name_cannot_be_empty: '触发器名称不能为空',
    range_cannot_be_empty: '范围不能为空',
    check_at_least_one_item: '至少勾选一项',
    repetition_times_cannot_be_empty: '重复次数不能为空',
    repetition_interval_cannot_be_empty: '重复间隔不能为空',
    up_to_seven_record_times: '最多七条记录时间',
    keep_at_least_one_piece_of_data: '至少保留一条数据',
    the_same_time_point_cannot_exist: '不能存在相同的时间点',
    keep_at_least_one_point_in_time: '至少保留一个时间点',
    approved_successfully: '审批成功',
    voice: '语音',
    short_message: '短信',
    mail: '邮件',
    no_forwarding: '无转发',
    three_times_smaller: '缩小三倍',
    shrink_twice: '缩小两倍',
    original_proportion: '原比例',
    zoom_in_twice: '放大两倍',
    zoom_in_three_times: '放大三倍',
    please_select_the_device_to_be_located: '请选择需要定位的设备',
    saved_successfully: '保存成功',
    collection_unit_cannot_be_empty: '采集单位不能为空',
    record_point_cannot_be_empty: '记录点不能为空',
    set_successfully: '设置成功',
    'are_you_sure_to_close_the_acquisition_record_point?':
      '您确定关闭采集记录点吗？',
    closed_successfully: '关闭成功',
    collection_record_is_not_opened: '未开启采集记录',
    record_point: '记录点',
    record_time: '记录时间',
    person_in_charge: '负责人',
    autograph: '签名',
    alarm_trigger_setting: '报警触发设置',
    selection_area_provides_data: '选择区提供数据',
    need_to_deal_with: '需要处理',
    edit_mode: '编辑模式',
    chinese_comma_and_center_line_cannot_be_entered: '不能输入中文逗号及中线',
    mount_status_cannot_be_empty: '资产状态不能为空',
    mount_name_cannot_be_empty: '资产名称不能为空',
    record_date: '记录日期',
    approval_time: '审批时间',
    approval: '审批',
    approver: '审批人',
    export: '导出',
    approved: '审批通过',
    approval_rejected: '审批拒绝',
    not_approved: '未审批',
    the_selected_data_has_approved_data: '所选择的数据存在已审批的数据',
    please_select_the_same_mounting_data_for_approval:
      '请选择相同的资产数据进行审批',
    please_select_the_same_time_record_point_data: '请选择相同的时间记录点数据',
    the_same_mount_name_exists: '存在相同的资产名称',
    the_range_of_the_user_is_inconsistent_with_the_current_page_range:
      '用户组织架构范围与当前页面范围不一致',
    save_failed: '保存失败',
    behavior: '行为',
    operator: '操作人',
    data: '数据',
    abnormal_record: '异常记录',
    mount_information: '资产信息',
    to_update: '更新',
    alarm_settings: '报警触发',
    cancel_device: '取消设备',
    mount_auxiliary_settings: '资产辅助设置',
    handling_exceptions: '处理异常',
    delete_exception: '删除异常',
    set_recording_point: '设置记录点',
    close_record_point: '关闭记录点',
    update_mount: '更新资产',
    delete_mount: '删除资产',
    set_alarm: '设置报警',
    no_parameter_data: '无参数数据',
    add_mount: '新增资产',
    belonging_to: '组织架构',
    name_of_monitoring_point: '资产名称',
    type: '类型',
    traceable: '可追踪',
    alarm_on: '报警开启',
    label: '标签',
    describe: '描述',
    yes: '是',
    no: '否',
    please_select_at_least_one_data: '请至少选择一条数据',
    time_cannot_be_empty: '时间不能为空',
    temperature: '温度',
    real_time_data_collection: '实时采集数据',
    store_collected_data: '存储采集数据',
    check_at_least_one_architecture_point: '至少勾选一个架构点',
    type_cannot_be_empty: '类型不能为空',
    last_week: '最近一周',
    last_month: '最近一个月',
    last_three_months: '最近三个月',
    guangzhou_disease_control: '广州疾控',
    pop_up_button: '弹窗按钮',
    equipment_details: '设备详情信息',
    historical_line_chart: '历史折线图',
    whether_to_start_heartbeat: '是否开启心跳',
    gateway_type_: '网关类型',
    display_status: '显示屏状态',
    relay_status: '中继状态',
    first_case: '第一种情况',
    offline_duration: '离线时长',
    offline_times: '离线次数',
    second: '秒',
    configuration_success_times: '配置成功次数',
    configuration_times: '配置次数',
    duration_of_power_failure: '断电时长',
    outage_times: '断电次数',
    offline_analysis: '离线分析',
    configuration_analysis: '配置分析',
    outage_analysis: '断电分析',
    data_analysis_settings: '数据分析设置',
    data_board: '数据看板',
    refresh_content: '刷新内容',
    real_time_situation: '实时情况',
    data_analysis: '数据分析',
    check_at_least_one_item_of_data: '至少勾选一项数据',
    no_data_temporarily: '暂无数据',
    please_view_first: '请先选择要查看的设备',
    fixed_test_point: '固定测试点',
    move_test_point: '移动测试点',
    click_to_see_more: '点击查看更多',
    start_date_cannot_be_later_than_end_date: '开始日期不能大于结束日期',
    the_left_section_cannot_be_greater_than_the_right_section:
      '左区间不能大于右区间',
    display: '显示屏',
    abnormal_duration: '异常时长',
    number_of_exceptions: '异常次数',
    alarm_trigger_times: '报警触发次数',
    times: '次',
    normal_abnormal_proportion: '正常异常比例',
    monitoring_point_status: '资产状态',
    monitoring_point_type: '类型',
    pause_alarm: '暂停报警',
    only_numbers_can_be_entered: '只能输入数字',
    display_type_cannot_be_empty: '显示屏类型不能为空',
    time_zone_cannot_be_empty: '时区不能为空',
    the_display_name_cannot_be_empty: '显示屏名称不能为空',
    screen_nickname_cannot_be_empty: '显示屏昵称不能为空',
    the_display_number_cannot_be_empty: '显示屏编号不能为空',
    duration_cannot_be_empty: '持续时间不能为空',
    initialization_command: '初始化命令',
    modify_configuration: '修改配置',
    some_commands_are_configured: '部分命令已配置',
    configuration_successful: '配置成功',
    configuration_steps: '配置步骤',
    detection_interval: '检测间隔',
    rule_escalation: '规则上报',
    modify_customer: '编辑公司',
    are_you_configuring: '是否正在配置',
    display_creation_time: '显示屏创建时间',
    display_deactivation_time: '显示屏停用时间',
    the_selected_display_screen_is_not_the_same_customer:
      '所选择的显示屏不是同一客户',
    new_display: '新增显示屏',
    the_selected_sensor_is_not_the_same_customer: '所选择的传感器不是同一客户',
    gateway_type_cannot_be_empty: '网关类型不能为空',
    gateway_serial_number_cannot_be_empty: '网关序列号不能为空',
    gateway_nickname_cannot_be_empty: '网关昵称不能为空',
    channel_mask_cannot_be_empty: '信道掩码不能为空',
    gateway_deactivation_time: '网关停用时间',
    the_selected_gateway_is_not_the_same_customer: '所选择的网关不是同一客户',
    form_template: '表格模板',
    new_gateway: '新增网关',
    edit_gateway: '编辑网关[{mac}]',
    download_successful: '下载成功',
    relay_type_cannot_be_empty: '中继类型不能为空',
    relay_number_cannot_be_empty: '中继编号不能为空',
    relay_nickname_cannot_be_empty: '中继昵称不能为空',
    relay_name: '中继名称',
    relay_creation_time: '中继创建时间',
    add_relay: '新增中继',
    sensor_deactivation_time: '传感器停用时间',
    voltage: '电压',
    forwarding_gateway_name: '转发网关名称',
    normal_acquisition_interval: '正常采集间隔',
    the_selected_sensor_has_a_disabled_status: '所选择的传感器存在停用状态',
    please_select_the_same_temperature_or_temperature_humidity_sensor:
      '请选择相同的温度或者温湿度传感器',
    minimum_temperature: '最小温度',
    maximum_temperature: '最大温度',
    minimum_humidity: '最小湿度',
    maximum_humidity: '最大湿度',
    configuration_completed: '已配置完成',
    overtime: '超时',
    number_cannot_be_empty: '编号不能为空',
    new_sensor: '新增传感器',
    storage: '存储',
    humidity: '湿度',
    successfully_modified: '修改成功',
    please_input_a_password: '请输入密码',
    please_enter_the_password_again: '请再次输入密码',
    old_password_cannot_be_empty: '旧密码不能为空',
    the_new_password_cannot_be_empty: '新密码不能为空',
    confirmation_cannot_be_empty: '确认不能为空',
    userInformation_not_found: '找不到用户信息',
    the_old_password_is_incorrect: '旧的密码不正确',
    agent_management: '代理管理',
    customer_use: '企业使用',
    customer_management: '企业管理',
    platform_usage: '平台使用',
    platform_management: '平台管理',
    male: '男',
    female: '女',
    unknown: '未知',
    user_name_cannot_be_empty: '用户名称不能为空',
    email_address_cannot_be_empty: '电子邮箱不能为空',
    boot_function: '引导功能',
    view_accessible_operation_resources: '查看可访问操作资源',
    electronic_signature_: '电子签名',
    change_password: '修改密码',
    unit_setting: '单位设置',
    user_name_already_exists: '用户名称已存在',
    email_address_is_required_and_must_conform_to_the_email_format:
      '电子邮箱为必填项且必须符合邮件格式',
    mobile_number_is_required_and_must_conform_to_the_format_of_mobile_number:
      '手机号码为必填项且必须符合手机号码格式',
    email_address_already_exists: '电子邮箱已存在',
    'are_you_sure_to_turn_boot_on_or_off?': '您确认开启或者关闭引导吗？',
    resources: '资源',
    map_architecture: '地图架构',
    current_schema_not_found_on_map: '没有在地图上找到当前架构',
    custom_event_name: '自定义事件名称',
    incorrect_verification_code_input: '验证码输入不正确',
    sign_in: '登录',
    login_successful: '登录成功',
    plan: '平面图',
    'real-time_data_': '实时数据',
    page_not_found: '找不到页面',
    the_specified_time_cannot_be_empty: '指定时间不能为空',
    record_point_setting: '记录点设置',
    setting_failed: '设置失败',
    data_already_exists: '数据已存在',
    record_point_time_repetition: '记录点时间重复',
    record_points_cannot_be_repeated: '记录点不能重复',
    mount_type_details: '资产类型详细信息',
    edit_mount_type: '编辑资产类型',
    select_at_least_one_application_object: '至少选择一个应用对象',
    new_mount_type: '新增资产类型',
    enable_status_cannot_be_deleted: '启用状态无法删除',
    only_positive_integers_are_allowed: '只允许正整数',
    length_cannot_be_empty: '长度不能为空',
    logout_successful: '注销成功',
    activation_successful: '激活成功',
    customer_name_cannot_be_empty: '企业名称不能为空',
    customer_code_cannot_be_empty: '企业ID不能为空',
    customer_status_cannot_be_empty: '企业状态不能为空',
    contact_information_cannot_be_empty: '联系方式不能为空',
    customer_type_cannot_be_empty: '企业类型不能为空',
    the_same_customer_name_already_exists: '已存在相同的企业名称',
    the_same_customer_code_already_exists: '已存在相同的企业ID',
    the_same_email_already_exists: '已存在相同的电子邮箱',
    the_same_mobile_number_already_exists: '已存在相同的手机号码',
    email_format_error: '电子邮箱格式错误',
    runhui_science_park: '润慧科技园',
    keep_at_least_one_data: '至少保留一个数据',
    uom_already_exists: '计量单位已存在',
    unit_tag_already_exists: '单位标记已存在',
    unit_number_already_exists: '单位编号已存在',
    function_code_cannot_be_empty: '功能码不能为空',
    function_cannot_be_empty: '功能不能为空',
    activation: '激活',
    cancellation: '注销',
    mount_type_icon: '资产类型图标',
    exception_category_icon: '异常种类图标',
    end_date_cannot_be_earlier_than_start_date: '结束日期不能小于开始日期',
    please_enter_the_start_date: '请输入开始日期',
    please_select_data: '请选择数据',
    please_select_a_file: '请选择文件',
    statistics: '统计',
    year_on_year: '同比',
    month_on_month: '环比',
    year: '年',
    month: '月',
    anomaly_analysis: '异常分析',
    alarm_trigger_analysis: '报警触发分析',
    normal_and_abnormal_proportion_analysis: '正常异常比例分析',
    proportion: '比例',
    closed_connection_exception_alarm: '已关闭连接异常报警',
    connection_exception_alarm_started: '已启动连接异常报警',
    power_off_abnormal_alarm_has_been_turned_off: '已关闭断电异常报警',
    power_failure_abnormal_alarm_has_been_started: '已启动断电异常报警',
    data_abnormal_alarm_has_been_turned_off: '已关闭数据异常报警',
    data_abnormal_alarm_started: '已启动数据异常报警',
    mail_notification_turned_off: '已关闭邮件通知',
    mail_notification_started: '已启动邮件通知',
    sms_notification_has_been_turned_off: '已关闭短信通知',
    sms_notification_started: '已启动短信通知',
    voice_notification_turned_off: '已关闭语音通知',
    voice_notification_started: '已启动语音通知',
    display_type_icon: '显示屏类型图标',
    display_status_icon: '显示屏状态图标',
    configuration_status_icon: '配置状态图标',
    gateway_type_icon: '网关类型图标',
    sensor_status_icon: '传感器状态图标',
    running_state_: '运行状态',
    whether_to_configure: '是否配置',
    relay_type_icon: '中继类型图标',
    relay_status_icon: '中继状态图标',
    operation: '操作',
    framework: '架构',
    sensor_type_icon: '传感器类型图标',
    nickname_cannot_be_empty: '昵称不能为空',
    only_english_or_numbers_can_be_entered: '只能输入英文或者数字',
    type_code_cannot_be_empty: '类型编码不能为空',
    data_type_cannot_be_empty: '数据类型不能为空',
    rule_cannot_be_empty: '规则不能为空',
    please_select_a_device_type: '请选择设备类型',
    please_enter_the_number_or_name: '请输入编号或者名称',
    please_select_a_reason: '请选择原因',
    please_fill_in_the_handler: '请填写处理人',
    please_enter_a_name: '请输入名称',
    system_automatic: '系统自动',
    custom: '自定义',
    please_enter_the_location: '请输入地点',
    please_enter_longitude: '请输入经度',
    please_enter_the_latitude: '请输入纬度',
    please_upload_the_plan: '请上传平面图',
    select_picture: '选择图片',
    confirm_upload: '确定上传',
    editing_mode: '编辑模式',
    please_enter_your_mobile_number: '请输入手机号码',
    please_enter_wechat: '请输入微信',
    please_enter_weibo: '请输入微博',
    reason: '原因',
    please_enter_a_task: '请输入任务',
    please_enter_the_interval: '请输入间隔',
    print: '打印',
    please_enter_the_level_name: '请输入层级名称',
    whether_to_automatically_save_the_alarm_object_to_the_contact:
      '是否自动将报警对象保存到联系人中',
    select_a_time_range: '选择时间范围',
    minute: '分钟',
    cancel: '取消',
    select: '选中',
    export_format: '导出格式',
    please_select_the_export_format: '请选择导出格式',
    analysis_of_monitoring_points: '资产分析',
    track: '追踪',
    data_conditions: '数据条件',
    select_date: '选择日期',
    please_select: '请选择',
    selected_monitoring_points: '选中的资产',
    preview: '预览',
    pass_category: '通过类别',
    monitoring_point: '资产',
    mounting_details: '资产详情',
    statistical_time: '统计时间',
    analysis_type: '分析类型',
    please_select_analysis_type: '请选择分析类型',
    gateway: '网关',
    gateway_details: '网关详情',
    start_year: '开始年份',
    end_year: '结束年份',
    escalation_rules: '上报规则',
    export_template: '导出模板',
    no_picture_yet: '暂无图片',
    attribute: '属性',
    application: '应用',
    please_enter_the_customer_name: '请输入客户名称',
    please_enter_the_customer_profile: '请输入客户简介',
    please_enter_the_code: '请输入编码',
    please_enter_the_area: '请输入区域',
    please_enter_the_customer_address: '请输入客户地址',
    please_enter_the_contact_person: '请输入联系人',
    please_enter_the_contact_information: '请输入联系方式',
    carrier_c: '资产:',
    console_c: '控制台:',
    equipment_type: '设备类型',
    code: '编码',
    subunits: '子单元',
    place: '地点',
    longitude: '经度',
    latitude: '纬度',
    position: '位置',
    number_of_used: '使用数',
    collection_unit: '采集单位',
    collection_strategy: '采集策略',
    collection_strategy_1: '最新收集点',
    collection_strategy_des_1: '系统将会使用资产里的传感器采集到最接近指定的记录点的时间点的数据作为记录数据',
    specified_time: '指定时间',
    start: '开始',
    end: '结束',
    offline_rate: '离线率',
    pass_rate: '通过率',
    export_data: '导出数据',
    please_select_the_preview_monitoring_point: '请选择预览的资产',
    sign: '标记',
    file: '文件',
    exception_analysis_settings: '异常分析设置',
    alarm_trigger_analysis_settings: '报警触发分析设置',
    normal_abnormal_proportion_analysis_setting: '正常异常比例分析设置',
    sensor_not_associated: '未关联传感器',
    gateway_not_associated: '未关联网关',
    uncorrelated_display: '未关联显示屏',
    unassociated_relay: '未关联中继',
    show_all_properties: '显示所有属性',
    'pop-up_notification': '弹窗',
    display_number: '显示屏编号',
    switch_settings: '开关设置',
    import_display: '导入显示屏',
    number: '编号',
    sensor_nickname: '传感器昵称',
    file_type: '文件类型',
    whether_to_use_electronic_signature: '是否使用电子签名',
    no_signature_information_yet: '暂无签名信息',
    old_password: '旧的密码',
    new_password: '新的密码',
    confirm_password: '确认密码',
    temp_unit: '温度单位',
    celsius:'摄氏度',
    fahrenheit:'华氏度',
    kelvin:"开尔文",
    user_account: '用户账号',
    user_name: '用户名称',
    gender: '性别',
    function: '功能',
    type_name: '类型名称',
    type_code: '类型编码',
    type_status: '类型状态',
    customer_name: '企业名称',
    customer_profile: '企业简介',
    customer_code: '企业ID',
    customer_status: '状态',
    customer_type: '企业类型',
    region: '区域',
    customer_address: '地址',
    contacts: '联系人',
    contact_information: '手机/电话号码',
    'e-mail': '电子邮箱',
    inform_the_customer: '通知客户',
    the_meaning_of_the_icon_is_as_follows_c: '图标代表的含义如下:',
    sensor_type_icon_c: '传感器类型图标:',
    exception_type_icon_c: '异常种类图标:',
    location: '定位',
    system_customization: '系统自定义',
    print_grouping: '打印分组',
    data_collection_time_setting: '数据采集时间设置',
    use_current_user_name: '使用当前用户名称',
    record_point_data: '记录点数据',
    use_existing: '使用已有的',
    use_new_signature: '使用新签名',
    total_duration: '总时长',
    please_select_a_preview_device: '请选择预览的设备',
    detection_equipment_monitoring: '设备实时信息',
    save_the_selected_device: '保存所选设备',
    monitoring_point_monitoring: '资产监测',
    attribute_list: '属性列表',
    display_icon_c: '显示屏图标:',
    gateway_status_icon_c: '网关状态图标',
    configuration_status_icon_c: '配置状态图标:',
    send_out: '发送',
    log_content_c: '日志内容:',
    eliminate: '清除',
    journal: '日志',
    configuration_log: '配置日志',
    gateway_icon_c: '网关图标:',
    relay_icon_c: '中继图标:',
    relay_status_icon_c: '中继状态图标:',
    sensor_status_icon_c: '传感器状态图标:',
    mount_type_icon_c: '资产类型图标:',
    network_parameters: '网络参数',
    role: '角色',
    accessible_organization: '可访问组织',
    operable_resources: '可交互资源',
    return_to_the_home_page: '返回首页',
    picture_cannot_be_empty: '图片不能为空',
    email_notification: '邮件通知',
    sms_notification: '短信通知',
    download: '下载',
    refuse: '拒绝',
    confirm: '确定',
    return: '返回',
    monitoring_interval: '报警区间',
    range: '区间',
    details: '详情',
    detection_value: '探测值',
    device_type_type_icon_c: '设备类型类型图标:',
    close: '关闭',
    remove: '移除',
    refresh: '刷新',
    deactivate: '停用',
    enable: '启用',
    time_selection: '时间选择',
    stay: '在',
    any_point_in_time: '任意时间点',
    use_printer: '使用打印机',
    group_name: '分组名称',
    please_enter_the_group_name: '请输入分组名称',
    print_settings: '打印设置',
    print_data: '进行数据打印',
    the_group_name_already_exists: '该分组名称已存在',
    please_enter_the_name: '请输入名称',
    please_enter_the_number: '请输入号码',
    please_enter_email: '请输入邮箱',
    abnormal_connection: '连接终端',
    abnormal_data: '数值超限',
    abnormal_power_failure: '断电',
    a_uom_can_only_correspond_to_one_monitoring_interval:
      '一个计量单位只能对应一个监测区间',
    alarm_mode: '报警方式',
    forwarding_platform: '转发平台',
    no_reason_for_alarm: '暂无报警原因',
    no_alarm_mode: '暂无报警方式',
    the_record_point_has_not_been_opened_yet: '未开启数据采集记录',
    open_record_point: '开启记录点',
    use_default_settings: '使用默认设置',
    delete_record_point: '删除记录点',
    record_details: '记录详细',
    view_history: '查看历史',
    acquisition_time: '采集时间',
    offline_category: '离线类别',
    no_preview_data_yet: '暂无预览的数据',
    time_zone: '时区',
    uncorrelated_monitoring_interval: '未关联监测区间',
    please_select_a_test_point: '请选择测试点',
    search: '搜索',
    show_anchors: '显示锚点',
    please_select_a_carrier: '请选择一个载体',
    preservation: '保存',
    archit: '架构',
    down_time_: '停用时间',
    battery_powered: '电池供电',
    creation_time: '创建时间',
    command_form: '命令形式',
    current_step: '当前步骤',
    sampling_detection_value: '取样探测值',
    please_enter_the_length: '请输入长度',
    please_enter_a_description: '请输入描述',
    data_type: '数据类型',
    length: '长度',
    rule: '规则',
    explain: '说明',
    save_the_selected_monitoring_point: '保存所选资产',
    group_name_cannot_be_empty: '分组名称不能为空',
    operation_failed: '操作失败',
    operation_successful: '操作成功',
    please_upload_the_picture_before_positioning: '请先上传图片再进行定位',
    please_select_a_monitoring_point: '请选择资产',
    time_tag: '时间标签',
    to: '至',
    successful_execution: '执行成功',
    transmit_power_cannot_be_empty: '发射功率不能为空',
    the_network_access_interval_cannot_be_empty: '入网间隔不能为空',
    please_select_the_shortcut_bar_icon: '请选择快捷栏图标',
    abroad: '国外',
    mac_address: 'MAC地址',
    mac_address_c: 'MAC地址:',
    at_instruction_c: 'AT指令:',
    qq_format_is_incorrect: 'QQ格式不正确',
    tcp_connection: 'tcp连接',
    tcp_connection_service_exception: 'TCP连接服务异常',
    tcp_connection_service_is_normal: 'TCP连接服务正常',
    lte_connection_server_exception: 'LTE连接服务器异常',
    lte_connection_server_is_normal: 'LTE连接服务器正常',
    zbp_thermometer: 'zbp温度计',
    trace_is_not_an_array: 'trace不是数组',
    extpanid_cannot_be_empty: 'extPanId不能为空',
    at_instruction: 'AT指令',
    mac_cannot_be_empty: 'mac不能为空',
    at_instruction_cannot_be_empty: 'AT指令不能为空',
    let_connection_status: 'let连接状态',
    url_already_exists: 'URL已存在',
    choice: '选择',
    handler: '处理人',
    temperature_sampling_value: '温度取样值',
    humidity_sampling_value: '湿度取样值',
    the_two_passwords_are_inconsistent_e: '两次输入密码不一致!',
    unable_to_locate_the_vehicle_e: '无法定位该车辆!',
    reason_type_icon: '原因类型图标',
    default_condition: '是否默认条件',
    processing_details: '处理详细',
    type_of_anomaly: '异常种类',
    customize_users: '自定义用户',
    current_user: '当前用户',
    handler_cannot_be_blank: '处理人不能为空',
    check_at_least_one_method: '至少勾选一种方式',
    content_cannot_be_empty: '内容不能为空',
    record: '记录',
    are_you_sure_you_want_to_perform_this_operation_q: '你确定要执行此操作吗?',
    _c_: ',',
    normal_size: '正常大小',
    the_selected_data_has_a_synchronization_user_c__which_cannot_be_deleted:
      '选择的数据存在同步用户,同步用户不可删除',
    no_matching_data_found: '找不到匹配的数据',
    file_has_been_deleted: '文件已被删除',
    file_does_not_exist: '文件不存在',
    unknown_error: '未知错误',
    delete: '删除',
    download_status: '下载状态',
    download_failed_c__parameter_error: '下载失败,参数错误',
    download_failed_c__the_file_does_not_exist: '下载失败,该文件不存在',
    download_failed_the_file_has_been_deleted: '下载失败,该文件已被删除',
    detection_task_status: '检测任务状态',
    alarm_strategy: '报警策略',
    level_alarm: '层级报警',
    click_to_enable_email_alarm: '点击开启邮件报警',
    click_to_close_the_email_alarm: '点击关闭邮件报警',
    click_to_enable_sms_alarm: '点击开启短信报警',
    click_to_close_sms_alarm: '点击关闭短信报警',
    click_to_enable_voice_alarm: '点击开启语音报警',
    click_to_close_the_voice_alarm: '点击关闭语音报警',
    set_up: '设置',
    service_number: '服务编号',
    cancel_work_order: '取消工单',
    acceptance: '受理',
    comment: '评语',
    cancellation_succeeded: '撤销成功',
    accepted_successfully: '受理成功',
    processing_confirmation_c__processing_result_cannot_be_empty:
      '处理确认操作,处理结果不能为空',
    confirmation_succeeded: '确认成功',
    star_rating_cannot_be_empty: '评星不能为空',
    evaluation_success: '评价成功',
    transaction_type: '事务类型',
    processing_results: '处理结果',
    problem_description: '问题描述',
    acceptance_method: '受理方式',
    submitter: '提交人',
    acceptor: '受理人',
    submission_time: '提交时间',
    acceptance_time: '受理时间',
    confirmation_time: '确认时间',
    leaving_a_message: '留言',
    please_enter_a_message: '请输入留言',
    evaluate: '评价',
    please_enter_comments: '请输入评语',
    reminder_of_submitting_work_order: '提交工单提醒人员',
    reminder: '提醒人员',
    wechat: '微信',
    select_at_least_one_reminder_method: '至少选择一种提醒方式',
    submit: '提交',
    customer: '企业',
    "submitter's_mobile_phone": '提交人手机号码',
    transaction_no: '事务编号',
    please: '请对',
    approval_of_record_points: '记录点进行审批',
    please_select_at_least_one_data_e: '请至少选择一条数据!',
    operation_succeeded_e: '操作成功!',
    no_pictures_of_monitoring_points: '暂无资产图片',
    data_collection_record_is_not_enabled: '未开启数据采集记录',
    system_error_c__please_contact_the_relevant_administrator:
      '系统错误,请联系相关管理员',
    previous_page: '上一页',
    next_page: '下一页',
    auxiliary_settings_of_monitoring_point_equipment: '资产设备辅助设置',
    monitoring_point_status_cannot_be_empty: '资产状态不能为空',
    monitoring_point_name_cannot_be_empty: '资产名称不能为空',
    'the_file_already_exists._do_you_want_to_overwrite_it':
      '文件已存在,是否覆盖',
    rear_alarm: '后报警',
    sampling_is_used_to_represent_an_overall_value_of_the_monitoring_point_within_the_monitoring_range:
      '取样用于表示资产在监测区间内的一个整体数值',
    set_start_time: '设置开始时间',
    set_end_time: '设置结束时间',
    qr_code: '二维码',
    click_to_load_more: '点击加载更多',
    query_data: '查询数据',
    generate_query_code: '生成查询码',
    download_qr_code: '下载二维码',
    total_passing_time: '通过总时长',
    total_length_of_failure: '未通过总时长',
    total_running_time: '运行总时长',
    total_offline_time: '离线总时长',
    the_customer_of_the_account_does_not_need_to_sign_c__please_fill_in_a_new_signature:
      '该账号组织架构客户没用签名,请填写新的签名',
    view_tracks: '查看轨迹',
    please_select_the_device_to_analyze_first: '请先选择要分析的设备',
    no_selected_device_data: '无选定设备数据',
    this_device_already_exists: '已存在此设备',
    no_associated_devices_found: '没有找到关联设备',
    monitoring_point_has_no_associated_map_unit: '资产没有关联地图单元',
    detailed_information: '详细信息',
    please_select_a_track_point: '请选择轨迹点',
    no_track_found_e: '未查询到轨迹!',
    real_time_trajectory: '实时轨迹',
    historical_track: '历史轨迹',
    no_action_track_detected: '未监测到行动轨迹',
    this_map_unit_has_no_monitoring_points: '该地图单元没有资产',
    no_monitoring_point_data: '无资产数据',
    open_anchor: '开启锚点',
    multiple_combined_numbers_are_separated_by_commas_and_are_numbers:
      '多个组合数字以英逗号隔开,且为数字',
    above_safety_range: '高于安全范围',
    below_safety_range: '低于安全范围',
    modification_succeeded_c__please_login_again: '修改成功,请重新登录',
    need_to_be_dealt_with: '待办',
    fixed_monitoring_point: '固定资产',
    mobile_monitoring_point: '移动资产',
    unable_to_locate_the_mobile_monitoring_point_e: '无法定位该移动资产!',
    unassociated_device: '未关联设备',
    time: '时间',
    speed: '速度',
    sampling: '取样',
    unrelated_temperature_range: '未关联温度区间',
    unrelated_humidity_range: '未关联湿度区间',
    sensor: '传感器',
    relay: '中继',
    'deleting_a_monitoring_point_type_will_delete_all_data_under_this_type._are_you_sure_you_want_to_do_this_q':
      '删除资产类型将会删除该类型下的所有数据,是否确认此操作?',
    decimal_type_c__the_length_is_separated_by_a_comma_c__and_only_one_comma_is_allowed:
      '小数类型,长度以逗号隔开,且只能一个逗号',
    platform_or_not: '是否平台',
    view_positioning: '查看定位',
    'deleting_a_device_type_will_delete_all_data_under_that_type._are_you_sure_you_want_to_do_this_q':
      '删除设备类型将会删除该类型下的所有数据,是否确认此操作?',
    system_error_c__please_contact_the_administrator: '系统错误，请联系管理员',
    submitter_quo_s_mobile_phone: '提交人手机号码',
    work_order_status: '工单状态',
    please_enter_the_end_date: '请输入结束日期',
    archit_: '架构',
    monitoring_point_details: '资产详情',
    collection_interval_cannot_be_empty: '采集间隔不能为空',
    exception_collection_interval_cannot_be_empty: '异常采集间隔不能为空',
    the_temperature_collection_interval_cannot_be_empty: '温度采集间隔不能为空',
    temperature_change_threshold_cannot_be_empty: '温度变化阈值不能为空',
    the_maximum_temperature_reporting_interval_cannot_be_empty:
      '温度最大上报间隔不能为空',
    the_minimum_reporting_interval_of_temperature_cannot_be_empty:
      '温度最小上报间隔不能为空',
    humidity_collection_interval_cannot_be_empty: '湿度采集间隔不能为空',
    humidity_change_threshold_cannot_be_empty: '湿度变化阈值不能为空',
    the_maximum_humidity_reporting_interval_cannot_be_empty:
      '湿度最大上报间隔不能为空',
    the_minimum_humidity_reporting_interval_cannot_be_empty:
      '湿度最小上报间隔不能为空',
    jingxian_county: '景县',
    trigger_settings: '触发器设置',
    please_enter_the_name_of_the_monitoring_point: '请输入资产名称',
    title: '标题',
    query_code: '查询码',
    login_code: '登录码',
    please_use_the_applet_to_scan_and_log_in_within_five_minutes:
      '请于五分钟内使用小程序扫描登录',
    current: '当前',
    collection: '采集',
    temperature_range_without_monitoring: '未关联温度区间',
    click_sign_out: '点击注销',
    click_activate: '点击激活',
    please_pass_in_an_array_with_the_correct_format: '请传入正确格式的数组',
    please_pass_in_the_object_property: '请传入对象属性',
    branch: '分',
    surplus: '剩余',
    turn_off_alarm: '关闭报警',
    turn_on_alarm: '开启报警',
    delay_normal_alarm: '延迟正常报警',
    delay_ignore_alarm: '延迟忽略报警',
    no_matter_whether_the_data_becomes_normal_within_the_delay_time_c__the_abnormal_alarm_will_still_alarm:
      '不管在延迟时间内数据是否变为正常,异常的报警照常报警',
    a_delay_alarm_is_set_in_the_layered_alarm_dot__within_the_delay_time_c__the_data_becomes_normal_again_c__and_the_alarm_trigger_will_ignore_the_alarm_and_will_not_alarm_again:
      '在分层报警中设置了延迟报警,在延迟时间内,数据再次变为正常,报警触发器将会忽略报警,不再报警',
    default: '默认',
    deactivation_status: '停用状态',
    alarm_off: '报警关闭',
    untraceable: '不可追踪',
    heat_insulation_box: '保温箱',
    'off-line': '离线',
    configuring: '配置中',
    normal_request_response_c__but_failed: '正常请求回应,但结果失败',
    the_account_does_not_exist: '账号不存在',
    password_error: '密码错误',
    login_credential_expired_c__please_login_again: '登录凭证过期,请重新登录',
    no_permission_c__please_contact_the_administrator: '没有权限,请联系管理员',
    credential_error: '账号、邮箱或密码错误',
    login_failed: '登录失败',
    login_conflict: '登录冲突',
    do_not_log_in_again: '请勿重复登录',
    the_requested_resource_does_not_exist: '请求的资源不存在',
    wrong_request_method: '请求方式有误',
    network_anomaly: '网络异常',
    exporting_data: '导出数据中',
    export_succeeded: '导出成功',
    zhang_shan: '张珊',
    asa: '阿萨',
    li_si: '李四',
    // nothing: '无',
    please_enter_the_correct_name_e: '请输入正确姓名!',
    please_enter_the_correct_email_e: '请输入正确的邮箱!',
    id_card_cannot_be_empty: '身份证不能为空',
    'please_enter_the_correct_second-generation_id_card_number':
      '请输入正确的二代身份证号码',
    phone_cannot_be_empty: '电话不能为空',
    only_english_letters_and_numbers_can_be_included: '只能包含英文字母和数字',
    cannot_contain_spaces: '不能包含空格',
    it_can_only_contain_english_letters_c__numbers_and_underscores:
      '只能包含英文字母和数字以及下划线',
    param_code_can_only_contain_letters_numbers_and_symbols:
      '只能包含大小写英文、数字及符号（不能包含空格）',
    please_fill_in_the_address_correctly: '请正确填写地址',
    only_numbers_or_letters_can_be_entered_e: '只能输入数字或字母!',
    two_decimal_places_and_numbers: '两位小数且是数字',
    no_decimal_point: '禁止小数点',
    please_enter_a_number: '请输入数字',
    parameter_verification_failed: '参数校验不通过',
    track_information: '轨迹信息',
    'this_operation_will_remove_all_monitoring_point_anchors._are_you_sure_this_operation_q':
      '此操作将会移除所有的资产锚点,您确认此操作吗?',
    this_operation_will_remove_all_monitoring_point_anchors_dot__are_you_sure_this_operation_q:
      '此操作将会移除所有的锚点,您确认此操作吗?',
    deleting_a_monitoring_point_type_will_delete_all_data_under_this_type_dot__are_you_sure_you_want_to_do_this_q:
      '删除资产类型将会删除该类型下的所有数据,是否确认此操作?',
    deleting_a_device_type_will_delete_all_data_under_that_type_dot__are_you_sure_you_want_to_do_this_q:
      '删除设备类型将会删除该类型下的所有数据,是否确认此操作?',
    after: '后',
    processing_confirmation: '处理确认',
    continue_processing: '继续处理',
    back: '返回',
    confirm_close: '确认关闭',
    edit: '编辑',
    please_select_trigger: '请选择触发器',
    temperature_detection_value: '温度探测值',
    humidity_detection_value: '湿度探测值',
    please_enter_an_integer_greater_than_zero: '请输入一个大于零的整数',
    length_is_less_than_30: '长度为30以内',
    name_length_is_within_30: '名称长度在30以内',
    code_length_is_within_50: '编码长度在50以内',
    '3_times_smaller': '缩小3倍',
    '2x_smaller': '缩小2倍',
    zoom_in_2x: '放大2倍',
    zoom_in_3x: '放大3倍',
    length_within_50: '长度在50以内',
    length_within_20: '长度在20以内',
    length_within_255: '长度在255以内',
    length_within_100: '长度在100以内',
    interval_length_is_within_4: '间隔长度在4以内',
    please_enter_an_integer_greater_than_0: '请输入一个整数且大于0',
    please_enter_a_positive_integer_greater_than_0: '请输入大于0正整数',
    please_enter_an_integer_greater_than_or_equal_to_0:
      '请输入一个大于等于0的整数',
    the_length_of_monitoring_point_is_within_50: '资产长度在50以内',
    the_length_of_monitoring_point_is_within_250: '资产长度在250以内',
    length_cannot_exceed_80: '长度不能超过80',
    the_length_is_8_hex_bases_c__i_dot_e_dot__18:
      '长度为8个十六进制,既长度为18',
    the_length_of_trunk_number_cannot_be_greater_than_50:
      '中继编号长度不能大于50',
    number_length_cannot_be_greater_than_30: '编号长度不能大于30',
    length_less_than_50: '长度50以内',
    length_within_120: '长度在120以内',
    customer_name_cannot_be_greater_than_50_in_length: '企业名称不能大于50长度',
    company_name_cannot_be_greater_than_50_in_length: '公司名称不能大于50长度',
    the_customer_abbreviation_cannot_be_greater_than_30:
      '企业简称不能大于30长度',
    the_area_cannot_be_longer_than_120: '区域不能大于120长度',
    the_customer_address_cannot_be_greater_than_255_in_length:
      '企业地址不能大于255长度',
    customer_contact_cannot_be_longer_than_30: '企业联系人不能大于30长度',
    description_cannot_be_longer_than_250: '描述不能大于250长度',
    name_within_20: '名称在20以内',
    type_name_within_20: '类型名称在20以内',
    length_within_80: '长度80以内',
    see: '查看',
    return_to_search_criteria: '返回搜索条件',
    current_value: '当前值',
    maximum: '最大值',
    minimum_value: '最小值',
    average_value: '平均值',
    anchor_list_c: '锚点列表:',
    configuration_details: '配置详情',
    plan_information: '平面图信息',
    plan_editing: '平面图编辑',
    no_description_information: '暂无描述信息',
    customer_location: '地理位置',
    contents_menu: '目录菜单',
    example: '示例',
    organizational_unit: '组织架构',
    alarm_reason: '起因',
    alarm_level: '报警层级',
    alarm_object: '报警对象',
    phone_number: '手机号码',
    alarm_time: '报警时间',
    alarm_content: '报警内容',
    hierarchy: '层级',
    'no_dot_/name': '编号/名称',
    'equipment_name/no': '设备名称/编号',
    sensor_temp: '传感器温度',
    sensor_hum: '传感器湿度',
    now_in_viewing_status_c__please_return_to_processing_status:
      '现在处于查看状态，请返回到处理状态',
    processed_c__processing_information_can_be_viewed_in_the_record:
      '已处理，可在记录中查看处理信息',
    processing_times_c__click_to_process_exception_records:
      '处理次数,点击处理异常记录',
    point_data_arrival_c: 'point数据到达:',
    this_operation_will_delete_its_child_nodes_and_monitoring_points_dot__do_you_want_to_continue_q:
      '此操作将会删除其下的子节点以及资产，是否继续？',
    same_record_exists_c__duplicate_record_skipped:
      '存在相同的记录，已跳过重复的记录',
    please_enter_an_msn: '请输入MSN',
    please_enter_skype: '请输入Skype',
    only_generated_and_failed_records_can_be_deleted:
      '只能删除已生成、生成失败的记录',
    _quo_this_operation_will_permanently_delete_this_information_dot__are_you_sure_you_want_to_do_this_q_quo_:
      '此操作将永久删除该信息，您确认此操作吗',
    when_the_unit_is_seconds_c__it_cannot_be_less_than_10:
      '单位为秒的时，不能小于10',
    this_operation_will_clear_the_alarm_object_and_its_contacts:
      '此操作，将会清除报警对象及其联系人',
    there_is_data_with_usage_times_other_than_0_and_cannot_be_deleted:
      '存在使用次数不为0的数据，无法删除',
    whole: '全部',
    default_settings_not_found_c__please_contact_administrator:
      '未找到默认设置，请联系管理员',
    no_gateway_zigbee_related_parameters: '无网关Zigbee相关参数',
    currently_in_view_mode_c__unable_to_process: '当前处于查看模式，无法处理',
    query_code_valid_time_c_7_days: '查询码有效时间:7天',
    this_file_already_exists_dot__do_you_want_to_overwrite_it_q:
      '此文件已存在，是否需要进行覆盖？',
    warn_c_illegal_year: 'WARN:年份不合法',
    alarm_data_delay: '数据延迟',
    alarm_offline_delay: '离线延迟',
    alarm_switch: '报警开关',
    alarm_volume_: '报警音量',
    number_of_alarms: '报警次数',
    number_of_labels_per_page: '标签每页数量',
    the_mac_length_cannot_be_greater_than_30: 'mac长度不能大于30',
    the_mac_length_cannot_be_greater_than_50: 'mac长度不能大于50',
    alarm_parameters: '报警参数',
    mqtt_address: 'MQTT地址',
    mqtt_port: 'MQTT端口',
    mqtt_connection_timeout: 'Mqtt连接超时时间',
    mqtt_automatic_reconnection: 'Mqtt自动重连',
    data_storage_time: '数据保存时间',
    equipment_limited_quantity: '设备限定数量',
    to_configure: '配置',
    no_gateway_zigbee_parameter: '无网关Zigbee参数',
    relay_mac: '中继Mac',
    forwarding_gateway_mac: '转发网关MAC',
    appeui_cannot_be_empty: 'AppEUI不能为空',
    appkey_cannot_be_empty: 'AppKey不能为空',
    deveui_cannot_be_empty: 'DevEUI不能为空',
    the_password_length_exceeds_the_limit: '密码长度超出限制',
    the_selected_data_has_an_enabled_state_and_cannot_be_deleted:
      '所选数据存在启用状态，无法删除',
    select_at_least_one_monitoring_point_type: '资产类型至少选择一项',
    customer_creation_succeeded_c__but_default_role_creation_failed:
      '创建客户成功，但创建默认角色失败',
    create_customer_c__default_role_succeeded_c__but_create_user_failed:
      '创建客户，默认角色成功，但创建用户失败',
    create_customer_c__default_role_c__user_succeeded_c__but_contact_synchronization_failed:
      '创建客户，默认角色，用户成功，但同步联系人失败',
    customer_code_can_only_be_filled_in_uppercase_and_lowercase_english_letters_c__and_numbers_cannot_be_greater_than_20_in_length:
      '客户编码只能填写大小写英文字母，数字且不能大于20长度',
    company_code_can_only_be_filled_in_uppercase_and_lowercase_english_letters_c__and_numbers_cannot_be_greater_than_20_in_length:
      '公司ID只能填写大小写英文字母，数字且不能大于20长度',
    the_area_code_can_only_be_filled_in_uppercase_and_lowercase_english_letters_c__numbers_c__and_underscores_c__and_cannot_be_greater_than_20_in_length:
      '区域编码只能填写大小写英文字母，数字，下划线，且不能大于20长度',
    contact_information_can_only_be_filled_with_numbers_and_middle_bars_c__and_cannot_be_greater_than_20_in_length:
      '联系方式只能填充数字以及中杠，且不能大于20长度',
    customer_editing_succeeded_c__but_default_role_editing_failed:
      '编辑客户成功，但编辑默认角色失败',
    _quo_edit_customer_c__default_role_succeeded_c__but_edit_user_failed_quo_:
      '编辑客户，默认角色成功，但编辑用户失败',
    _quo_edit_customer_c__default_role_c__user_succeeded_c__but_contact_synchronization_failed_quo_:
      '编辑客户，默认角色，用户成功，但同步联系人失败',
    only_english_c__numbers_c__and_underscores_are_allowed:
      '只允许英文、数字、下划线',
    open: '打开',
    coordinator_name: '协调器名称',
    configuration_information: '配置信息',
    gateway_coordinator: '网关协调器',
    self_ip_attribute: '自身IP属性',
    private_ip: '私有ip',
    switch_proxy_customers: '切换代理企业',
    switching_succeeded_c__please_log_in_again: '切换成功，请重新登录',
    the_current_customer_is_already_a_selected_customer_and_does_not_need_to_be_switched:
      '当前客户已是选择客户，不需要切换',
    device_records_associated_with_monitoring_points_c__activated_c__and_in_use:
      '关联了资产,已激活且正在使用的设备记录',
    device_records_that_have_been_activated_and_are_in_use_c__but_have_not_been_associated_with_a_monitoring_point:
      '已激活且正在使用的,但没有进行资产关联的设备记录',
    device_records_associated_with_a_monitoring_point_and_activated_c__but_the_device_has_been_deactivated:
      '关联了资产且已激活,但设备已经停用的设备记录',
    equipment_records_that_have_been_added_but_have_not_been_activated:
      '新增了设备,但并未进行设备激活的设备记录',
    server_error_c__request_failed_c__please_contact_management:
      '服务器出错，请求失败，请联系管理人员',
    login_expired_c__please_login_again: '登录过期，请重新登录',
    server_error_c__please_contact_administrator: '服务器出错，请联系管理员',
    request_timed_out_c__please_contact_the_administrator:
      '请求超时，请联系管理员',
    a_system_error_occurred_and_the_download_failed: '发生系统错误，下载失败',
    the_file_is_corrupted_dot__please_rebuild_it_and_try_again:
      '文件已损坏，请重新生成再试',
    extpanid_format_is_hexadecimal: 'extPanId格式为十六位十六进制',
    wang_wu: '王五',
    it_quo_s_json: '是JSON',
    the_input_content_is_a_positive_integer_and_the_maximum_length_is_5:
      '输入内容为正整数且最长为5',
    cannot_exceed_255: '不能超过255',
    cannot_be_greater_than_327: '不能大于327',
    cannot_be_greater_than_30: '不能大于30',
    cannot_be_less_than_0: '不能小于0',
    cannot_be_greater_than_26: '不能大于26',
    cannot_be_less_than_11: '不能小于11',
    cannot_be_greater_than_60: '不能大于60',
    cannot_be_greater_than_20: '不能大于20',
    cannot_be_greater_than_100: '不能大于100',
    please_enter_the_correct_url_e: '请输入正确的URL!',
    length_cannot_exceed_100: '长度不能超过100',
    the_length_can_only_be_16_bits: '长度只能是16位',
    the_content_is_only_in_figures_and_english: '内容仅为数字、英文',
    the_length_can_only_be_10_digits: '长度只能是10位',
    the_length_can_only_be_32_bits: '长度只能是32位',
    add: '新增',
    architecture: '架构',
    start_time: '开始时间',
    end_time: '结束时间',
    no_query_data_temporarily: '暂无查询数据',
    real_time_situation_of_monitoring_points: '资产实时情况',
    'exception_type_(icon_illuminated_as_exception)':
      '异常类型(图标亮起为异常)',
    'duration_(seconds)': '持续时间(秒)',
    'interval_time_(seconds)': '间隔时间(秒)',
    'time_interval_(seconds)': '时间间隔(秒)',
    'alarm_time_(seconds)': '报警时间(秒)',
    'alarm_interval_(seconds)': '报警间隔(秒)',
    'network_access_interval_(seconds)': '入网间隔(秒)',
    volts: '伏(V)',
    cannot_be_empty: '不能为空',
    data_record: '数据记录',
    adopt: '通过',
    input_verification_failed: '输入校验不通过',
    continued: '持续',
    not_applied: '未应用',
    be_applied_to: '应用于',
    type_details: '类型详细信息',
    query_was_successful: '查询成功',
    successfully_added: '新增成功',
    edit_failed: '编辑失败',
    edit_succeeded: '编辑成功',
    alarm_trigger_bound_to_carrier: '报警触发已绑定载体',
    display_name_already_exists: '显示屏名称已存在',
    import_an_empty_file: '导入空文件',
    import_failed: '导入失败',
    import_succeeded: '导入成功',
    please_re_import_the_correct_template_file: '请重新导入正确的模板文件',
    gateway_mac_already_exists: '网关MAC已存在',
    sending_succeeded: '发送成功',
    fail_in_send: '发送失败',
    purge_succeeded: '清除成功',
    mac_is_empty: 'Mac为空',
    the_parent_menu_does_not_exist_c__it_may_have_been_deleted:
      '父菜单不存在，可能已被删除',
    query_failed: '查询失败',
    successfully_saved_in_batch: '批量保存成功',
    sort_succeeded: '排序成功',
    sort_failed: '排序失败',
    definition: '定义',
    historical_data_: '历史数据',
    'only_jpg/png_files_can_be_uploaded_c__and_no_more_than_500kb':
      '只能上传jpg/png文件，且不超过500kb',
    'please_enter/select_a_contact_person': '请输入/选择联系人',
    'when_the_unit_is_minute/hour_c__it_cannot_be_less_than_1':
      '单位为分/时的时，不能小于1',
    'please_enter_a_number/name': '请输入编号/名称',
    'when_logging_off_a_customer_c__the_associated_roles/users/monitoring_tools/monitoring_points_will_be_deactivated_dot__are_you_sure_you_want_to_log_off_q':
      '注销客户时,将会将相关联角色/用户/监测工具/资产停用,是否确定注销？',
    record_point_closed: '记录点已关闭',
    more: '更多',
    there_are_currently_no_monitoring_points_available: '暂无资产',
    normal_time: '正常运行时间',
    abnormal_time: '异常时间',
    monitoring_device_connection_failure: '监测设备连接失败',
    standby_power_supply_for_device_startup: '设备启动备用电源',
    no_comment_information: '无备注信息',
    installation_point: '安装位置',
    remarks: '备注',
    closing_time: '关闭时间',
    duration: '持续时间',
    processing_records: '处理记录',
    not_closed: '未关闭',
    abnormal_record_details: '事件信息',
    abnormal_cause: '起因',
    please_fill_in_the_reason: '请填写原因',
    unable_to_find_corresponding_reason: '找不到对应原因',
    '': '自定义异常原因已存在',
    system_abnormality: '系统异常',
    of: '的',
    abnormal_object: '异常对象',
    must_select_the_same_customer: '必须选择同一客户',
    unprocessed: '未处理',
    are_you_sure_you_want_to_delete_this_exception_q: '你确定要删除该异常吗?',
    details_of_abnormal_content: '异常内容详细',
    abnormal_content: '异常内容',
    process_and_stop_alarms: '处理并停止报警',
    alarm_triggering: '报警触发',
    the_deleted_schema_is_a_scope_and_cannot_be_deleted:'被删除架构是范围，不可删除',
    the_schema_is_in_use_and_cannot_be_deleted: '该架构正在使用，不可删除',
    interval_alarm_or_not: '是否间隔报警',
    alarm_interval: '报警间隔',
    there_is_currently_no_content_available: '暂无内容',
    the_minimum_unit_of_alarm_interval_is_minutes: '报警间隔最小单位为分',
    alarm_time_and_time_point_cannot_be_empty: '报警时间、时间点不能为空',
    alarm_record: '报警记录',
    please_select_the_same_customer: '请选择相同的客户',
    other_information: '其他信息',
    sampling_strategy: '取样策略',
    abnormal_detachment: '脱落异常',
    data_strategy: '数据策略',
    successfully_applied: '应用成功',
    installation_point_name: '安装位置名称',
    association_method: '关联方式',
    using_a_smart_base: '使用智能底座',
    please_enter_or_select_a_base_name: '请输入或选择底座名称',
    equipment_no: '设备编号',
    please_select_a_device_first: '请先选择设备',
    associated_devices: '关联的设备',
    base: '底座',
    base_strategy: '底座策略',
    please_add_a_probe_first: '请先添加探头',
    currently_associating_devices_c__please_complete_the_addition_before_switching:
      '当前正在关联设备,请新增完成后再做切换',
    currently_adding_c__please_save_or_delete_and_try_again:
      '当前正在新增,请保存或删除后再试',
    new_name: '新建名称',
    please_enter_the_association_name: '请输入关联名称',
    please_select_the_device_to_be_associated: '请选择需要关联的设备',
    the_device_is_already_bound_to_a_monitoring_point: '该设备已绑定资产',
    successfully_added_installation_point: '新增安装位置成功',
    are_you_sure_you_want_to_delete_this_item: '你确定要删除该项吗',
    are_you_sure_you_want_to_dissociate_this_device: '你确定要取消关联该设备吗',
    the_installation_point_does_not_exist: '该安装位置不存在',
    installation_point_details: '安装位置详情',
    please_select_a_smart_base: '请选择智能底座',
    the_device_has_been_associated_with_a_monitoring_point: '设备已关联资产',
    the_device_is_already_associated_with_the_current_monitoring_point:
      '设备已关联在当前资产',
    smart_sled_not_bound: '未绑定智能底座',
    chart: '图表',
    this_device_has_no_historical_data: '该设备无历史数据',
    please_select_a_schema_first: '请先选择架构',
    alarm_trigger_switch: '报警触发开关',
    please_select_a_monitoring_point_for_the_associated_trigger:
      '请选择关联触发器的资产',
    sampling_time: '取样时间',
    sampling_value: '取样值',
    rendering: '渲染',
    no_monitoring_interval: '无监测区间',
    equipment: '设备',
    eq_off:'设备(离线)',
    eq_on:'设备(在线)',
    collect_data: '采集数据',
    news: '消息',
    unassociated_monitoring_points: '未关联资产',
    vcn_switcher_: '转发网关',
    bind_device: '绑定设备',
    base_number: '底座编号',
    base_type: '底座类型',
    nickname: '昵称',
    the_base_type_cannot_be_empty: '底座类型不能为空',
    the_base_nickname_cannot_be_empty: '底座昵称不能为空',
    the_base_code_cannot_be_empty: '底座编码不能为空',
    import_smart_base: '导入智能底座',
    start_date: '开始日期',
    end_date: '结束日期',
    binding_history: '绑定历史',
    device_selection: '设备选择',
    please_enter_the_device_number: '请输入设备编号',
    do_you_want_to_force_replacement: '是否强制替换',
    unassociated_base: '未关联底座',
    this_device_is_already_associated_with_a_base_dot__are_you_sure_you_want_to_forcibly_replace_it_q:
      '该设备已关联底座,你确定要强制替换吗?',
    binding_successful: '绑定成功',
    conflict_resolution: '冲突处理',
    the_base_conflicts_with_the_device_monitoring_point_dot__please_choose_the_following_handling_method_c:
      '底座与设备资产冲突,请选择以下处理方式:',
    bind_device_c__associate_to__b: '绑定设备，关联到[',
    bind_devices_and_disassociate_installation_points:
      '绑定设备，解除安装位置关联',
    base_binding_status: '底座绑定状态',
    data_processing: '数据处理',
    status: '状态',
    fall_off: '脱落',
    embed: '嵌入',
    binding: '绑定',
    unbound_monitoring_point: '未绑定资产',
    bound_monitoring_point: '已绑定资产',
    new_smart_base: '新增智能底座',
    analyze_data: '分析数据',
    viewing_data: '查看数据',
    fill_preview: '填充预览',
    fill_in_data: '填充数据',
    please_enter_the_gateway_name: '请输入网关名称',
    closed: '已关闭',
    monitoring_point_chart: '资产图表',
    event: '事件',
    event_information: '事件信息',
    company: '企业',
    batch_handle: '批量处理',
    handle_time: '处理时间',
    operation_time: '操作时间',
    trigger_name_: '触发器名称',
    work_order: '工单',
    secondment: '借调',
    alarm_switch_event: '报警开关事件',
    click_to_jump_to_the_download_page_for_download: ',点击跳转至下载页面下载',
    query: '查询',
    overall_situation_of_equipment_secondment: '设备借调总况',
    current_secondment: '当前借调',
    historical_secondment: '历史借调',
    revoke: '撤销',
    source_device: '源设备',
    secondment_to: '借调到',
    secondment_confirmation: '借调确认',
    select_all: '全选',
    please_select_at_least_one_piece_of_data: '请选择至少一条数据',
    equipment_secondment_cancellation: '设备借调撤销',
    revoke_confirmation: '撤销确认',
    are_you_sure_you_want_to_delete_these_data_q: '你确定要删除这些数据吗?',
    secondment_remarks: '借调备注',
    revoke_remarks: '撤销备注',
    please_select_the_unit_that_needs_to_be_seconded_to:
      '请选择需要借调到的单元',
    explanation_c_when_the_equipment_is_seconded_c__the_original_monitoring_points_c__organizational_structure_c__etc_dot__associated_with_the_equipment_will_be_revoked:
      '说明:当设备借调时,设备原来关联的资产,组织架构等均会撤销',
    type_of_seconded_equipment: '借调设备类型',
    secondment_view: '借调查看',
    equipment_secondment: '设备借调',
    only_devices_currently_on_secondment_can_view_details:
      '仅有正在借调中的设备才能查看详情',
    equipment_secondment_details: '设备借调详情',
    cannot_select_a_device_that_is_currently_being_seconded_for_secondment:
      '不能选择正在借调的设备进行借调',
    only_devices_currently_on_secondment_can_be_selected_for_cancellation:
      '仅能选择正在借调中的设备进行撤销',
    the_selected_record_must_be_a_seconded_record: '选中记录必须是已借调的记录',
    select_at_least_one_record: '至少选择一条记录',
    you_must_select_a_non_seconded_record: '必须选择未借调记录',
    thermometer_base: '智能底座',
    account_type: '账号类型',
    account_status: '账号状态',
    default_account: '是否默认账号',
    role_type: '角色类型',
    selected_data_state_has_start: '所选择的数据状态存在‘启动’状态，请重新选择',
    selected_data_state_has_stop: '所选择的数据状态存在‘停止’状态，请重新选择',
    please_select_device: '请选择设备',
    sign_as: '状态',
    confirm_abnormal_msg: '确定',
    suspected_abnormal_msg: '待定',
    confirm_normal_msg: '误报',
    display_info: '显示信息',
    phone_notification: '电话通知',
    each_week: '每周',
    each_month: '每月',
    each_year: '每年',
    last_day: '最后一天',
    notice_type: '状态',
    enter_rule_name: '请输入规则名称',
    temp_data_rule : '温度数据规则',
    hum_data_rule: '湿度数据规则',
    device_offline_rule: '设备离线规则',
    power_off_rule: '设备断电规则',
    rule_exists: '此规则已存在',
    unm_fault_tolerant: '数值容错',
    time_fault_tolerant: '时间容错',
    continuity_anomaly: '连续性异常',
    abnormal_frequency: '异常频率',
    reconnect_duration: '重连时长',
    power_duration: '断电时长',
    please_add_rule: '请添加规则',
    add_rule_title: '添加规则',
    select_point: '资产选择',
    rule_association: '关联无效规则',
    ex_state: '异常状况',
    quarter: '季度',
    direct_statistics: '直接统计',
    alarm_object_num: '报警对象数',
    one_quarter: '第一季度',
    two_quarter: '第二季度',
    three_quarter: '第三季度',
    four_quarter: '第四季度',
    exclude_abnormal: '状态',
    confirm_abnormal: '确认异常',
    suspected_abnormal: '疑似异常',
    sampling_frequency_cannot_be_empty: '采样频率不能为空',
    monitoring_interval_cannot_be_empty: '监测区间不能为空',
    gas_type_icon: '气体类型图标',
    gas_status_icon: '气体状态图标',
    temp_hum_type_icon: '温/湿度计类型图标',
    temp_hum_status_icon: '温/湿度计状态图标',
    new_gas: '新增气体',
    gas_code: '气体编码',
    gas_type: '气体类型',
    gas_status: '气体状态',
    alarm_threshold: '报警阈值',
    magnetism_code: '门磁编码',
    magnetism_type: '门磁类型',
    magnetism_type_icon: '门磁类型图标',
    magnetism_status_icon: '门磁状态图标',
    new_magnetism: '新增门磁',
    magnetism_status: '门磁状态',

    plane_unit: '平面单元',
    map_unit: '地图单元',

    buffer_interval: '预警区间',
    gas: '气体',
    magnetism: '门磁',
    display_buffer_interval: '显示缓冲区间',
    from: '起',
    // to: '止',
    data_compare: '数据比较',
    gps_p: 'GPS定位',
    async_mode: '异步模式',
    sync_mode: '同步模式',
    fix_mode: '固定模式',
    interval_variation_mode: '区间变化量模式',
    normal_mode: '普通模式',
    transport_mode: '运输模式',
    transportation_mode: '运输模式',
    no_relevant_parameters:'未获取到相关参数',
    audio_alarm: '声音报警',
    light_alarm: '灯光报警',
    sound_light_alarm: '声光报警',
    network_parameters_01: '一代网络参数',
    network_parameters_02: '二代网络参数',
    year_2: '年份',
    device_historical_line_chart: '设备历史折线图',
    sample_historical_line_chart: '取样历史折线图',
    carrier_historical_line_chart: '安装位置历史折线图',
    monitoring_point_mode_must_be_selected: '必须选择资产模式',
    label_carrier_name: '资产名称',
    label_carrier_status: '资产状态',
    registy: '注册',
    company_name: '公司名称',
    company_id: '公司ID',
    mobile: '手机号码',
    registy_checkbox_tip: '勾选此框，即表示您同意我们的',
    terms_and_conditions: '用户协议',
    privacy_policy: '隐私政策',
    and: '和',
    pwd_tips1: '密码格式错误,仅支持大小写字母、数字以及特殊字符,且长度在6~30位之间',
    registy_checkbox_tip2: '请勾选协议',
    visit_system_now: '不，我现在想访问系统',
    let_go: "好的",
    Registry_complete_tips: '注册完成。是否继续设备注册？',
    Registering: '注册中...',
    device_tips: '设备已注册。请激活设备。',
    device_enrollment: '设备注册',
    nothing: '没什么要做的',
    set_the_devices_now: "现在，让我们设置设备",
    coz: '气体',
    coz_net_tips: '二氧化碳类型不能和其他类型共同批量修改上报规则，请重新选择',
    no_device_tips: '未找到设备。请联系管理员。',
    browser: '浏览',
    unit_path: '单元路径',
    add_department: '添加部门',
    please_add_a_department: '请先添加子节点',
    please_add_plan_image: '请先上传平面图',
    organizational_no_plan: '当前组织单位没有可用的平面图。请选择一个带有平面图的。',
    organizational_no_map: '当前组织单位没有地图位置。请先定位。',
    custom_monitoring: '自定义资产',
    add_custom_monitoring: '自定义监测',
    select_device: '选择设备',
    cannot_add_child_nodes: '该组织结构不能添加子节点，请选择其他的节点',
    same_node_exists: '已存在相同节点',
    please_select_unit_path: '请选择单元路径',
    map: '地图',
    device_select_tips: '该设备已绑定资产，提交后设备会被强制切换到新资产',
    custom_device: '自定义监测设备',
    device_plan_location_tips: '该设备已绑定其他平面图，是否确定切换绑定？',
    map_no_open:'地图功能暂未开放，敬请期待',
    delete_anchor_points:'删除锚点',
    no_map_added:'该节点还没有地图，是否新增？',
    no_plan_added:'该节点还没有平面图，是否新增？',
    speed_grade_1:"正常速度",
    speed_grade_2:"快速",
    speed_grade_3:"较快",
    speed_grade_4:"极速",
    speed_grade_5:"最快",
    auto_configuration:"自动配置",
    please_select_lpwan_mode:"请选择LpwanMode",
    pan_id_cannot_be_empty:"Pan ID不能为空",
    join_attemp_cannot_be_empty:"Join Attemp不能为空",
    panid_format_is_hexadecimal: 'PanId格式为四位十六进制',
    ext_pan_id_cannot_be_empty:"Ext Pan ID不能为空",
    please_select_explain:"请选择说明",
    are_you_sure_you_want_to_delete_group: '你确定要删除该分组吗?',
    are_you_sure_you_want_to_delete_guide_item: '你确定要删除该引导项吗?',
    are_you_sure_you_want_to_modif_status_guide_item: '你确定要删除该引导项吗?',
    please_enter_at_command:"请输入AT指令,多个以分号(;)隔开",
    positioning_mode:"定位模式",
    please_select_address:"请输入地址",
    please_select_longitude:"请输入经度",
    please_select_latitude:"请输入纬度",
    associated_device: '关联设备',
    disassociated_device: '取消关联',
    exception_occurred:"发生的异常",
    realTime_status_detectio_device:'探测设备实时情况',
    picture:'图片',
    are_you_sure_you_want_to_delete_picture: '你确定要删除该图片吗?',
    upload_picture:'上传图片',

    // Invalid Rule 专用 keys
    ir_carrier: '资产',
    ir_installation_point: '安装位置',
    ir_carrier_type: '资产类型',
    ir_type: '异常类型',
    ir_close: '是否关闭',
    ir_close_header: '关闭',
    ir_abnormal_time: '发生时间',
    ir_belonging_to: '组织',
    ir_processing_results: '起因',
    ir_processing_records: '已处理记录',
    ir_abnormal_record: '事件记录',
    ir_application: '确定',
    ir_cancel: '取消',
    ir_time: '时间',
    ir_causes: '起因',
    ir_process_time: '处理时间',
    ir_status: '状态',
    log: 'Log',

    // 设备状态级联提示
    device_hint_pending: '设备已录入系统，等待首次数据上报。收到数据并校验通过后，自动转为"待绑"。',
    device_hint_unbound: '设备已通过数据校验，尚未关联资产（安装位置）。绑定资产后，设备方可投入业务使用。',
    device_hint_bound: '设备已成功绑定资产，业务功能完全生效，可正常监控数据并触发异常判断及告警规则。',
    device_hint_inactive: '设备已被手动停用，期间不参与任何业务监控，但历史数据完整保留。如需恢复，可随时重新启用。',
    // 底座策略/关联方式
    use_latest_device_data: '使用设备最新数据',
    force_use_latest_bound_device_data: '强制使用最新绑定设备数据',
    custom_processing_strategy: '自定义处理策略',
    force_replacement: '强制替换',
    prompt_duplicate: '提示重复',
  },
  asset: {
    mode: {
      normal_mode: '普通模式',
      transportation_mode: '运输模式'
    }
  },
  // ===== 账号系统改造 (feat-jri/account-redesign) =====
  accountRedesign: {
    // 登录 Tab
    tab_personal: '个人用户',
    tab_enterprise: '企业用户',
    // 登录表单
    label_company_id: 'Company ID',
    placeholder_company_id: '请输入 Company ID',
    placeholder_username_or_email: '请输入账号 / 电子邮箱',
    placeholder_password: '请输入密码',
    placeholder_captcha: '验证码',
    // Root 登录切换
    root_login_link: 'Root 登录（无需 Company ID）',
    back_to_enterprise_login: '返回普通企业登录',
    btn_root_login: 'Root 登 录',
    btn_switch_to_root: '以初始账号登录',
    btn_switch_to_enterprise: '以身份账号登录',
    // 注册
    register_title: '创建账号',
    register_type_personal: '个人注册',
    register_type_personal_desc: '适合个人使用，无需企业信息',
    register_type_enterprise: '企业注册',
    register_type_enterprise_desc: '需持有 Company ID，加入已有企业',
    badge_free: '免费',
    badge_need_company_id: '需 Company ID',
    // 注册表单
    label_username: '用户名',
    placeholder_username: '用户名（登录账号）',
    label_display_name: '显示名称',
    placeholder_display_name: '显示名称',
    label_email: '邮箱',
    placeholder_email: '请输入邮箱',
    label_mobile: '手机号码',
    placeholder_mobile: '请输入手机号码',
    label_password: '密码',
    placeholder_password_register: '密码（8-30位，需大小写字母+数字+特殊符号）',
    label_confirm_password: '确认密码',
    placeholder_confirm_password: '请再次输入密码',
    label_captcha: '验证码',
    // 企业注册步骤
    step_verify_company: '验证 Company ID',
    step_userInfo: '填写用户信息',
    btn_verify: '验证',
    btn_verifying: '验证中...',
    btn_verified: '已验证',
    company_verified_tip: '验证通过：{name}',
    apply_company_link: '还没有 Company ID？点击申请',
    // Company ID 申请
    apply_company_title: '申请 Company ID',
    label_company_name: '企业',
    placeholder_company_name: '请输入企业名称',
    label_contact_name: '联系人姓名',
    placeholder_contact_name: '请输入联系人姓名',
    label_contact_mobile: '手机/电话号码',
    placeholder_contact_mobile: '请输入手机/电话号码',
    label_contact_email: '邮箱',
    placeholder_contact_email: '请输入邮箱',
    label_description: '企业描述',
    placeholder_description: '请输入企业描述（可选）',
    apply_submitted_tip: '申请已提交，审核通过后会通过邮件通知您',
    // 忘记密码 / 重置密码 / 强制改密
    forget_password_title: '忘记密码',
    forget_password_tip: '请输入注册时填写的邮箱，系统将向该邮箱发送密码重置链接',
    btn_send_reset_link: '发送重置链接',
    reset_password_title: '重置密码',
    label_new_password: '新密码',
    placeholder_new_password: '请输入新密码',
    label_confirm_new_password: '确认新密码',
    placeholder_confirm_new_password: '请再次输入新密码',
    btn_reset_password: '重置密码',
    force_change_password_title: '首次登录修改密码',
    force_change_password_tip: '检测到您是首次登录，请修改初始密码后继续使用',
    label_old_password: '原密码',
    placeholder_old_password: '请输入原密码',
    btn_force_change: '确认修改',
    // 通用按钮 / 链接
    btn_login: '登 录',
    btn_register: '注 册',
    btn_cancel: '取消',
    btn_confirm: '确认',
    btn_ok: '确认',
    btn_close: '关闭',
    link_forget_password: '忘记密码',
    link_register: '注册',
    link_back_to_login: '已有账号？去登录',
    link_have_account_signin: '已有账号？登录',
    agree_policy_tip: '我已阅读并同意',
    policy_terms: '《服务条款》',
    policy_privacy: '《隐私政策》',
    policy_and: '和',
    // 错误提示
    err_account_frozen: '账号已被冻结',
    err_account_disabled: '账号已被禁用',
    err_user_type_mismatch: '用户类型与登录方式不匹配',
    err_company_code_not_exist: 'Company ID 不存在',
    err_company_code_already_applied: '该 Company ID 申请已提交，请勿重复申请',
    err_company_apply_not_found: '申请记录不存在',
    err_company_apply_already_processed: '申请已被处理',
    err_password_policy: '密码至少8位，需包含大小写字母、数字和特殊符号',
    err_invitation_expired: '邀请已过期，请联系管理员重新发送',
    err_first_login_change_required: '首次登录需要修改密码',
    err_password_not_match: '两次输入的密码不一致',
    err_captcha_incorrect: '验证码输入不正确',
    err_agree_policy_required: '请先勾选并同意服务条款和隐私政策',
    // 成功提示
    success_register_personal: '个人注册成功！请登录',
    success_register_enterprise: '企业注册成功！请登录',
    success_apply_submitted: '申请已提交，请耐心等待审核',
    success_send_reset_link: '重置链接已发送至您的邮箱',
    success_reset_password: '密码重置成功！请登录',
    success_force_change: '密码修改成功，请重新登录',
    force_change_failed: '密码修改失败，请重试',
    success_login_personal: '登录成功！',
    success_login_enterprise: '登录成功！',
    success_login_root: '登录成功！',
    login_failed: '账号或密码错误'
  }
}
